import type { SelectDropdownOption } from 'src/components/common/SelectDropdown';

export function isNamespaceListReady(
  namespaces: unknown[] | undefined,
): boolean {
  return namespaces !== undefined;
}

/**
 * Keep a saved namespace id visible (and the control disabled) until the
 * list loads, so the picker does not fall back to "unassigned" and persist
 * a clear if the user clicks it.
 */
export function selectedNamespacePickerOption(
  options: SelectDropdownOption[],
  value: string,
  noneOptionId: string,
  listReady: boolean,
  loadingDisplay: string,
): SelectDropdownOption {
  const match = options.find((option) => option.id === value);
  if (match) return match;
  if (!listReady && value !== noneOptionId) {
    return { id: value, label: loadingDisplay, display: loadingDisplay };
  }
  return options[0];
}
